import { Box, CheckBox } from "grommet";
import React from "react";
import { ImageTypes } from "./ContentStore";

const AllowedImageTypesSelector = ({ imageType, onChange, ...props }) => {
    return (
        <>
            <Box gap="small" {...props}>
                <CheckBox label="None" checked={imageType == ImageTypes.None} onChange={(e) => onChange(ImageTypes.None)}></CheckBox>
                <CheckBox label="Logo" checked={(imageType & ImageTypes.Logo) == ImageTypes.Logo} onChange={(e) => onChange(e.target.checked ? imageType | ImageTypes.Logo : imageType & ~ImageTypes.Logo)}></CheckBox>
                <CheckBox label="Splash" checked={(imageType & ImageTypes.Splash) == ImageTypes.Splash} onChange={(e) => onChange(e.target.checked ? imageType | ImageTypes.Splash : imageType & ~ImageTypes.Splash)}></CheckBox>
                <CheckBox label="All" checked={(imageType & ImageTypes.All) == ImageTypes.All} onChange={(e) => onChange(e.target.checked ? imageType | ImageTypes.All : imageType & ~ImageTypes.All)}></CheckBox>
            </Box>
        </>
    );
};

export default AllowedImageTypesSelector;
